import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useCustomerForm = () => {
  const [formDatas, setFormDatas] = useState({
    companyName: "",
    registrationNumber: "",
    phoneNumber: "",
    additionalPhoneNumber: "",
    yearsInOperation: "",
    fundingSource: "",
    website: ""
  });

  const navigate = useNavigate()

  useEffect(() => {
    const storedFormData = localStorage.getItem("customerFormData");
    if (storedFormData) {
      setFormDatas(JSON.parse(storedFormData));
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDatas({
      ...formDatas,
      [name]: value
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("customerFormData", JSON.stringify(formDatas));
    console.log(formDatas); 
    navigate("/Customeractivepage2");
  };

  return {
    formDatas,
    handleInputChange,
    handleFormSubmit
  };
};

export default useCustomerForm;




